<template>
  <div>
    <v-container class="fill-height mb-4" fluid>
      <v-card
        elevation="1"
        color="blue-grey lighten-1"
        :loading="loading"
        :disabled="loading"
      >
        <v-card-text>
          <v-btn
            color="yellow lighten-1"
            class="black--text"
            :block="$vuetify.breakpoint.xsOnly"
            :disabled="!is_studying || regis_type == 'M'"
            @click="open('M')"
          >
            รักษาสถานภาพนักศึกษา
            <v-icon right dark size="30">
              mdi-alpha-m-circle
            </v-icon>
          </v-btn>
          <v-btn
            class="black--text ml-0 ml-sm-3 mt-3 mt-sm-0"
            color="yellow lighten-1"
            :block="$vuetify.breakpoint.xsOnly"
            :disabled="!is_studying || regis_type == 'D'"
            @click="open('D')"
          >
            ลาพักการศึกษา
            <v-icon right dark size="30">
              mdi-alpha-d-circle
            </v-icon>
          </v-btn>
          <v-btn
            class="white--text ml-0 ml-sm-3 mt-3 mt-sm-0"
            color="red darken-4"
            :block="$vuetify.breakpoint.xsOnly"
            :disabled="!regis_type"
            @click="open('C')"
          >
            ยกเลิกการลงทะเบียน
            <v-icon right dark size="30">
              mdi-table-remove
            </v-icon>
          </v-btn>
        </v-card-text>
        <v-card-text class="pt-0 pb-2">
          <span
            :class="
              !is_studying ? 'yellow--text' : 'white--text'
            "
          >
            สถานะ : {{ student_status }}
          </span> </v-card-text
        >
      </v-card>
    </v-container>

    <v-dialog v-model="is_open" width="500">
      <v-card>
        <v-card-title>
          <span
            v-if="selected_regis_type == 'M'"
            class="red--text font-weight-bold"
            >ยืนยันการรักษาสถานภาพนักศึกษา</span
          >
          <span
            v-if="selected_regis_type == 'D'"
            class="red--text font-weight-bold"
            >ยืนยันการลาพักการศึกษา</span
          >
          <span
            v-if="selected_regis_type == 'C'"
            class="red--text font-weight-bold"
            >ยืนยันการยกเลิกการลงทะเบียน</span
          >
        </v-card-title>
        <v-card-text class="red pt-4 white--text">
          <h2 class="yellow--text">
            <v-icon color="yellow">mdi-alert</v-icon>ข้อควรระวัง
          </h2>
          <h3 class="white--text font-weight-regular pl-2">
            <li>หากมีการลงทะเบียนปกติไว้ วิชาเรียนจะถูกยกเลิกทั้งหมด</li>
            <li>หากมีการประกาศเกรดแล้ว ผลการเรียนจะถูกยกเลิกทั้งหมด</li>
          </h3>
        </v-card-text>
        <v-card-actions>
          <v-btn outlined color="red" @click="submit()">
            ยืนยัน
          </v-btn>
          <v-btn outlined color="dark" @click="clear">ปิดหน้าต่าง</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import RegistrationProvider from "@/services/registration.provider.js";
const RegistrationService = new RegistrationProvider();

export default {
  name: "RegisMD",
  props: {
    clear_student: {
      type: Function,
    },
    fetch_student: {
      type: Function,
    },
    level_id: {
      type: Number,
      default: null,
    },
    sub_level_id: {
      type: Number,
      default: null,
    },
    year: {
      type: String,
    },
    semester: {
      type: String,
    },
    student_id: {
      type: String,
    },
    student_info: {
      type: Object,
      default: null,
    },
    regis_type: {
      type: String,
    },
  },
  data: () => ({
    loading: false,
    is_open: false,
    selected_regis_type: null,
  }),
  computed: {
    student_status() {
      const studentInfo = this.student_info || this.$store.state.user.surrogated_student_info;
      return studentInfo ? studentInfo.status : null;
    },
    is_studying() {
      let data = false;
      if (this.student_status === "เรียน" || this.student_status === "ผ่าน") {
        data = true;
      }
      return data;
    },
  },
  methods: {
    open(value) {
      this.is_open = true;
      this.selected_regis_type = value;
    },

    clear() {
      this.is_open = false;
      this.selected_regis_type = null;
    },

    async submit() {
      this.loading = true;
      this.is_open = false;

      const response = await RegistrationService.regisMaintainAndDrop({
        level_id: this.level_id,
        sub_level_id: this.sub_level_id,
        year: this.year,
        semester: this.semester,
        student_id: this.student_id,
        regis_type: this.selected_regis_type,
      }).catch((error) => {
        this.loading = false;
        this.$toasted.error(JSON.stringify(error.response.data.message), {
          duration: 0,
        });
      });

      if (response) {
        if (!response.status)
          this.$toasted.error("ลงทะเบียนไม่สำเร็จ", { duration: 0 });
        else {
          this.$toasted.clear();
          this.$toasted.success("ลงทะเบียนสำเร็จ", { duration: 0 });
        }
      }

      this.loading = false;
      this.clear_student();
      this.fetch_student();
    },
  },
};
</script>
